import React, { useEffect, useState } from 'react';
import './profile.scss';
import { categoryType } from './data';
import ProfileCategories from './categories.tsx';
import { useScreenSize } from '../../../utils/media-query';

import Avatar from './avatar';
import Bank from './bank';
import WorkPlace from './workplace';
import Salary from './salary';
import Education from './education/education';
import { useParams } from 'react-router-dom';
import Family from './family';
import Contact from './contact';
import Identity from './identity';
import Policy from './policy';
import UndefinedIdentity from './undefined-identity.tsx';
import { usePublicEvents } from '../../../contexts/public-events.js';
import EmployeeDocumentList from './documents/employee-document-list.js';
import LeaveInformation from './leave-information.tsx';
import { EmploymentDocumentCheckList } from './employment-documents/employment-document-checklist.tsx';
import OverTime from './overtime.js';
import Travel from './travel.js';

function Profile() {
  const params = useParams()
  const [employeeId, setEmployeeId] = useState(params.id)
  const [employee, setEmployee] = useState()

  const screenSize = useScreenSize()
  const [selectedKey, setSelectedKey] = useState(categoryType.Identity)
  const { setPublicActivePageInfo } = usePublicEvents()

  function checkCategory(category) {
    if (screenSize.isXSmall) return true

    return selectedKey === category;
  }
  useEffect(() => {
    
    if (setPublicActivePageInfo){
      if (employee)
        setPublicActivePageInfo(employee)
      else
        setPublicActivePageInfo("Yeni Kayıt")
    }
      

    return () => {
      if (setPublicActivePageInfo)
        setPublicActivePageInfo(undefined)
    }
  }, [employee])

  return (
    <React.Fragment>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>

          {/* <div className='dx-card'>
          <Avatar />
          </div> */}
          {employee}
          {employee && <h3>{employee?.name}</h3>}
          <div className='dx-card'>
            {!screenSize.isXSmall &&
              <div className='left'>
                <ProfileCategories setSelectedKey={setSelectedKey} selectedKey={selectedKey} />
              </div>
            }

            <div className='right'>
              {checkCategory(categoryType.Identity) && <Identity employeeId={employeeId} setEmployeeId={setEmployeeId} setEmployee={setEmployee} />}
              {!checkCategory(categoryType.Identity) &&
                <UndefinedIdentity employeeId={employeeId}>
                  {checkCategory(categoryType.Contact) && <Contact employeeId={employeeId} />}
                  {checkCategory(categoryType.Banking) && <Bank employeeId={employeeId} />}
                  {checkCategory(categoryType.Workplace) && <WorkPlace employeeId={employeeId} />}
                  {checkCategory(categoryType.Salary) && <Salary employeeId={employeeId} />}
                  {checkCategory(categoryType.Education) && <Education employeeId={employeeId} />}
                  {checkCategory(categoryType.Family) && <Family employeeId={employeeId} />}
                  {checkCategory(categoryType.Policy) && <Policy employeeId={employeeId} />}
                  {checkCategory(categoryType.Documents) && <EmployeeDocumentList employeeId={employeeId} />}
                  {checkCategory(categoryType.Leave) && <LeaveInformation  employeeId={employeeId} />}
                  {checkCategory(categoryType.EmploymentCheckList) && <EmploymentDocumentCheckList  employeeId={employeeId} />}
                  {checkCategory(categoryType.OverTime) && <OverTime  employeeId={employeeId} />}
                  {checkCategory(categoryType.Seyahat) && <Travel  employeeId={employeeId} />}
                </UndefinedIdentity>
              }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const colCountByScreen = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4
};

export default Profile